import React, { useState } from 'react';
import styled from 'styled-components';
import { Modal } from '@shared/Modal';
import { Paragraph, Subtitle } from '../PointsRecovery/styles';
import { Filters } from './components/Filters';
import { RecoveryPointsList } from './components/RecoveryPointsList';
import { Department, RecoveryPointType } from './types';
import { SideInfoBlock } from './components/SideInfoBlock';
import media from '../../utils/mediaQueries';
import { MapImage } from '../common/MapImage';
import { Static } from '../ExamSearchResult/TopSearchParams/Static';
import { formatDateToDayString } from './helpers';
import { SearchPoints } from '../PointsRecovery/сomponents/SearchPoints';

const ListContainer = styled.div`
  display: flex;
  gap: 48px;
  align-items: flex-start;
  justify-content: flex-start;
  margin-top: 24px;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

const Container = styled.div`
  display: flex;
  gap: 48px;
  align-items: flex-start;
  justify-content: flex-start;
  width: 100%;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

const MapWrap = styled.div`
  height: 347px;

  & > a {
    height: 100%;
  }

  ${media.mobile`
    
  `}
`;

const FiltersContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

const SearchPointsContainer = styled.div`
  width: 65%;
  margin: 0 auto;

  @media (max-width: 768px) {
    width: 100%;
  }
`;

const HeaderFiltersContainer = styled.div`
  background-color: #fff;
  padding: 24px 16px;
  width: 100vw;
  left: 0;
  margin-left: calc(-50vw + 50%);
  z-index: 1;
  position: sticky;
  top: 0;
  border-top: 1px solid #f9f9f9;
`;

// TODO rewrite to using context to avoid prop drilling

type RecoveryPointsSearchResultComponentProps = {
  points: RecoveryPointType[];
  totalPages: number;
  totalPoints: number;
  activePage: number;
  selectedDate: string;
  handlePageChange(page: number): void;
  isPointsDataLoading: boolean;
  departmentFilters: Department[];
  dayPairs: { label: string; days: string[] }[];
  handleDaysCheckboxChange(label: string): void;
  handleDepartmentCheckboxChange(id: number): void;
  selectedPairs: {
    [key: string]: boolean;
  };
  selectedDepartments: {
    [key: string]: boolean;
  };
  selectedSort: {
    label: string;
    value: string;
  };
  handleSortChange(value: string): void;
  SORT_BY: { label: string; value: string }[];
  latitude: string;
  longitude: string;
  coordinates: string[][];
  placeTitle: string;
  filterModalVisible: boolean;
  mapModalVisible: boolean;
  toggleModal(type: string): void;
  isCityPage: boolean;
  handleDateChange?(date: Date): void;
};

const RecoveryPointsSearchResultComponent = ({
  points = [],
  totalPages,
  totalPoints,
  selectedDate,
  activePage,
  handlePageChange,
  isPointsDataLoading,
  departmentFilters,
  dayPairs,
  handleDaysCheckboxChange,
  handleDepartmentCheckboxChange,
  selectedPairs,
  selectedDepartments,
  selectedSort,
  handleSortChange,
  SORT_BY,
  latitude,
  longitude,
  coordinates,
  placeTitle,
  toggleModal,
  filterModalVisible,
  mapModalVisible,
  isCityPage,
  handleDateChange,
}: RecoveryPointsSearchResultComponentProps) => {
  const [searchPointsVisible, setSearchPointsVisible] = useState(false);
  const isMobile = window.innerWidth < 768;

  const formattedDate = formatDateToDayString(selectedDate);

  const renderHeaderContent = () => {
    if (searchPointsVisible) {
  return (
          <SearchPointsContainer>
            <SearchPoints />
          </SearchPointsContainer>
      );
    } else {
      return (
            <Static
              onModifyClick={() => setSearchPointsVisible(true)}
              isRecoveryPoints
              location={placeTitle}
              date={selectedDate}
              license=""
            />
      );
    }
    return null;
  };
  return (
    <>
      {!isCityPage && (
        <HeaderFiltersContainer isModalOpened={searchPointsVisible}>
          {renderHeaderContent()}
      </HeaderFiltersContainer>
      )}
      <Container>
        <div>
          {isCityPage ? (
            <Subtitle>Les stages de récupération de points à {placeTitle}</Subtitle>
          ) : (
            <Subtitle>Nous avons trouvé des stages pour vous !</Subtitle>
          )}
          <Paragraph>
            Il y a{' '}
            <strong>
              {totalPoints} {totalPoints > 1 ? 'stages' : 'stage'}
            </strong>{' '}
            {totalPoints > 1 ? 'disponibles' : 'disponible'} à <strong>{placeTitle}</strong> et ses
            alentours, à partir du <strong>{formattedDate}</strong>. Tous ces stages sont agréés par
            la préfecture. Récupérez jusqu&apos;à 4 points sur votre permis de conduire, en deux
            jours de formation.
          </Paragraph>
          <ListContainer>
            {!isMobile && (
              <FiltersContainer>
                <Filters
                  selectedPairs={selectedPairs}
                  handleDaysCheckboxChange={handleDaysCheckboxChange}
                  dayPairs={dayPairs}
                  departmentFilters={departmentFilters}
                  selectedDepartments={selectedDepartments}
                  handleDepartmentCheckboxChange={handleDepartmentCheckboxChange}
                  selectedSort={selectedSort}
                  handleSortChange={handleSortChange}
                  SORT_BY={SORT_BY}
                  isCityPage={isCityPage}
                  handleDateChange={handleDateChange}
                />
                {latitude && longitude && (
                  <MapWrap>
                    <MapImage
                      coordinates={coordinates}
                      link={`/stage-recuperation-de-points/centres?latitude=${latitude}&longitude=${longitude}`}
                      colors={['298a58', '298a58', '298a58', '298a58', '298a58', '298a58']}
                    />
                  </MapWrap>
                )}
              </FiltersContainer>
            )}

            {filterModalVisible && (
              <Modal isOpen={filterModalVisible} onClose={() => toggleModal('filter')}>
                <Filters
                  selectedPairs={selectedPairs}
                  handleDaysCheckboxChange={handleDaysCheckboxChange}
                  dayPairs={dayPairs}
                  departmentFilters={departmentFilters}
                  selectedDepartments={selectedDepartments}
                  handleDepartmentCheckboxChange={handleDepartmentCheckboxChange}
                  selectedSort={selectedSort}
                  handleSortChange={handleSortChange}
                  SORT_BY={SORT_BY}
                />
              </Modal>
            )}

            {mapModalVisible && (
              <Modal isOpen={mapModalVisible} onClose={() => toggleModal('map')}>
                <MapWrap>
                  <MapImage
                    coordinates={coordinates}
                    link={`/stage-recuperation-de-points/centres?latitude=${latitude}&longitude=${longitude}`}
                    colors={['298a58', '298a58', '298a58', '298a58', '298a58', '298a58']}
                  />
                </MapWrap>
              </Modal>
            )}

            <RecoveryPointsList
              points={points}
              totalPages={totalPages}
              activePage={activePage}
              handlePageChange={handlePageChange}
              isPointsDataLoading={isPointsDataLoading}
            />
          </ListContainer>
        </div>
        <SideInfoBlock />
      </Container>
    </>
  );
};

export { RecoveryPointsSearchResultComponent };
